<template>
  <div class="warm-range">
    <div class="second-title">
      {{ title }}
    </div>
    <el-switch
      v-model="localChecked"
      active-text="开启"
      inactive-text="关闭"
      @change="handleCheck"
    />
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localChecked: false,
    };
  },
  watch: {
    checked: {
      handler(val) {
        this.localChecked = val || false;
        this.$emit('handleCheck', this.localChecked);
      },
      immediate: true,
    },
  },
  // created() {
  //   this.localChecked = this.checked;
  //   this.$emit('handleCheck', this.localChecked);
  // },
  methods: {
    handleCheck() {
      this.$emit('handleCheck', this.localChecked);
    },
  },
};
</script>

<style lang="scss" scoped>
.warm-range{
  margin-bottom: 30px;
  .second-title{
    margin-bottom:8px;
  }
  .warm-container{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
}
</style>
